import moment from 'moment';

// History log `type` looks like "seo.update" / "help.page.create"; the last segment is the action.
const ACTIONS = {
  create: { label: 'Created', icon: 'add_circle', tone: 'success' },
  update: { label: 'Updated', icon: 'edit', tone: 'info' },
  delete: { label: 'Deleted', icon: 'delete', tone: 'danger' },
  import: { label: 'Imported', icon: 'upload', tone: 'accent' },
  reorder: { label: 'Reordered', icon: 'swap_vert', tone: 'neutral' },
  duplicate: { label: 'Duplicated', icon: 'content_copy', tone: 'neutral' },
};

export function getHistoryLogAction(historyLog) {
  const key = String((historyLog && historyLog.type) || '').split('.').pop();
  const action = ACTIONS[key];

  if (action) {
    return { key, ...action };
  }

  const label = key ? key.charAt(0).toUpperCase() + key.slice(1) : 'Changed';

  return { key, label, icon: 'history', tone: 'neutral' };
}

export function getRelativeTime(date) {
  return moment(date).fromNow();
}

export function formatDateTime(date) {
  return moment(date).format('DD MMM YYYY, HH:mm');
}

export function getInitials(email) {
  const name = String(email || '').split('@')[0];
  const parts = name.split(/[._-]+/).filter(Boolean);

  return (parts.length > 1 ? parts[0][0] + parts[1][0] : name.slice(0, 2)).toUpperCase() || '?';
}
